module.exports = __webpack_public_path__ + "media/images/pages/youtube-af56295b022a41265c09092e10147b6e.png";